var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6252_31656",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6252_31656)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.9791 14.6459C7.86798 14.6459 7.76034 14.6251 7.65618 14.5834C7.55201 14.5417 7.45132 14.4723 7.3541 14.3751L3.83326 10.8542C3.6666 10.6876 3.58673 10.4758 3.59368 10.2188C3.60062 9.96189 3.68743 9.75008 3.8541 9.58341C4.02076 9.41675 4.2291 9.33341 4.4791 9.33341C4.7291 9.33341 4.93743 9.41675 5.10409 9.58341L8.02076 12.5001L14.9166 5.60425C15.0833 5.43758 15.2881 5.35425 15.5312 5.35425C15.7742 5.35425 15.9791 5.43758 16.1458 5.60425C16.3124 5.77091 16.3958 5.97578 16.3958 6.21883C16.3958 6.46189 16.3124 6.66675 16.1458 6.83341L8.6041 14.3751C8.50687 14.4723 8.40618 14.5417 8.30201 14.5834C8.19785 14.6251 8.09021 14.6459 7.9791 14.6459Z",
    fill: "#D3135A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.8b37c78da36d27b215ea9af6df131bdc.svg";
export { ForwardRef as ReactComponent };